import { render } from "./EnterCodeTwoFactor.vue?vue&type=template&id=373c52d6&ts=true"
import script from "./EnterCodeTwoFactor.vue?vue&type=script&lang=ts"
export * from "./EnterCodeTwoFactor.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__